import Vue from 'vue';
import elementUI from 'element-ui';
import { plugin as http } from '@/modules/http';
import i18n from '@/modules/i18n';
import router from '@/modules/router';
import store from '@/modules/store';
import App from '@/App';

let statusCode = null;

// Register libs, plugins, and components
Vue.use(elementUI);
Vue.use(http);

// Vue config
Vue.config.productionTip = false;

// Get session data before the app is initialized
Vue.prototype.$http
  .get('/auth/session')
  .then(res => {
    statusCode = 200;
    store.commit('setMetadata', res.data.metadata);
    if (res.data.user) {
      store.commit('setUser', res.data.user);
    } else {
      store.commit('unsetUser');
    }
  })
  .catch(err => (statusCode = err.response.status))
  .finally(() => {
    // Initialize the app
    new Vue({
      render(h) {
        return h(App, {
          props: {
            statusCode
          }
        });
      },
      i18n,
      router,
      store
    }).$mount('#app');
  });
